import { createStep } from "@/Components/formik-steps";
import { useForm } from "@/Components/formik-steps";
import InfoPopperElement from "@/Components/InfoPopperElement";
import classNames from "classnames";
import { useEffect } from "react";
import axios from "axios";
import Preview from "@/Components/steps/Preview";

import * as yup from "yup";
import { useError } from "@/Components/formik-steps/Error";
import { showIcon } from "./Preview";
 

// export function TabIcon({
//   tab = {
//     value: "",
//   },
// }) {
//   console.log(tab.value)

//   if (tab.value === "tyre_repair") {
//     return (
//       <svg
//         width="29"
//         height="29"
//         viewBox="0 0 29 29"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >

//         <g clipPath="url(#clip0_157_4273)">
//           <path
//             d="M14.4997 4.83331C9.16958 4.83331 4.83301 9.16989 4.83301 14.5C4.83301 19.8301 9.16958 24.1667 14.4997 24.1667C19.8298 24.1667 24.1664 19.8301 24.1664 14.5C24.1664 9.16989 19.8298 4.83331 14.4997 4.83331ZM19.4452 8.44415C19.5537 8.32322 19.7071 8.2518 19.87 8.24534C20.0104 8.22943 20.1909 8.29785 20.3089 8.40994C21.5621 9.59645 22.4141 11.1069 22.7704 12.7778C22.8271 13.0444 22.6984 13.3159 22.4565 13.4409C21.8653 13.7466 21.1632 13.8946 20.4906 13.8946C19.6139 13.8946 18.7831 13.6433 18.3017 13.1618C17.2775 12.1382 17.7046 10.3747 19.4452 8.44415ZM9.55429 20.6502C9.44571 20.7711 9.29232 20.8431 9.12948 20.8496C9.1224 20.8502 9.11413 20.8502 9.10586 20.8502C8.95129 20.8502 8.80261 20.7912 8.69052 20.685C7.43734 19.4985 6.58536 17.988 6.22903 16.3166C6.17239 16.0499 6.30102 15.7785 6.54293 15.6534C7.90469 14.9507 9.84695 15.0817 10.6977 15.9325C11.7208 16.9562 11.2936 18.7197 9.55429 20.6502ZM10.6977 13.1619C10.2162 13.6433 9.3855 13.8947 8.50876 13.8947C7.83615 13.8947 7.13522 13.7466 6.54288 13.441C6.30096 13.3159 6.17233 13.0445 6.22897 12.7778C6.58536 11.1069 7.43729 9.59651 8.69046 8.41C8.80844 8.29791 8.98193 8.2283 9.12943 8.2454C9.29227 8.25191 9.44565 8.32328 9.55423 8.44421C11.2948 10.3747 11.7219 12.1382 10.6977 13.1619ZM17.0745 22.5566C16.2378 22.8232 15.3717 22.9584 14.4997 22.9584C13.6277 22.9584 12.7615 22.8233 11.9249 22.5566C11.6594 22.4716 11.486 22.2167 11.5048 21.9388C11.6559 19.7646 12.9433 18.125 14.4997 18.125C16.0561 18.125 17.3435 19.7646 17.4946 21.9388C17.5134 22.2167 17.34 22.4716 17.0745 22.5566ZM12.083 14.5C12.083 13.1672 13.1674 12.0833 14.4997 12.0833C15.8319 12.0833 16.9164 13.1671 16.9164 14.5C16.9164 15.8329 15.8319 16.9167 14.4997 16.9167C13.1674 16.9167 12.083 15.8328 12.083 14.5ZM17.4946 7.10896C17.3435 9.28255 16.0561 10.9222 14.4997 10.9222C12.9433 10.9222 11.6559 9.28255 11.5048 7.10896C11.486 6.83108 11.6582 6.5762 11.9237 6.49181C13.597 5.95723 15.4024 5.95723 17.0757 6.49181C17.3412 6.5762 17.5134 6.83108 17.4946 7.10896ZM22.7704 16.2205C22.414 17.8919 21.5621 19.4024 20.3089 20.5889C20.1968 20.6951 20.0482 20.7541 19.8936 20.7541C19.8853 20.7541 19.877 20.7541 19.87 20.7535C19.7071 20.747 19.5537 20.6756 19.4452 20.5547C17.7046 18.6242 17.2775 16.8601 18.3017 15.8364C19.1525 14.9851 21.0936 14.8558 22.4565 15.5574C22.6984 15.6824 22.8271 15.9538 22.7704 16.2205Z"
//             fill="#070707"
//           />
//           <path
//             d="M14.5 0C6.50421 0 0 6.50484 0 14.5C0 22.4952 6.50421 29 14.5 29C22.4958 29 29 22.4952 29 14.5C29 6.50484 22.4958 0 14.5 0ZM14.5 25.375C8.50317 25.375 3.625 20.4963 3.625 14.5C3.625 8.50374 8.50317 3.625 14.5 3.625C20.4968 3.625 25.375 8.50374 25.375 14.5C25.375 20.4963 20.4968 25.375 14.5 25.375Z"
//             fill="#070707"
//           />
//         </g>
//         <defs>
//           <clipPath id="clip0_157_4273">
//             <rect width="29" height="29" fill="white" />
//           </clipPath>
//         </defs>
//       </svg>
//     );
//   } else if (tab.value === "apk") {
//     return (
//       <svg
//         width="40"
//         height="40"
//         viewBox="0 0 40 40"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <rect width="40" height="40" rx="8" fill="#F5F5F5" />
//         <path
//           d="M27.9926 8.79954H25.369V7.62583C25.369 7.2461 24.9548 7.07351 24.575 7.07351H22.5383C22.055 5.69266 20.8468 5.00224 19.4659 5.00224C18.1003 4.95089 16.8581 5.78827 16.3936 7.07351H14.3913C14.0116 7.07351 13.6319 7.2461 13.6319 7.62583V8.79954H11.0082C9.45343 8.81612 8.18148 10.0426 8.1084 11.5957V31.3763C8.1084 32.8953 9.48925 33.9999 11.0082 33.9999H27.9926C29.5116 33.9999 30.8924 32.8953 30.8924 31.3763V11.5958C30.8193 10.0426 29.5474 8.81612 27.9926 8.79954ZM15.0126 8.45436H16.9113C17.2428 8.41392 17.509 8.16177 17.5673 7.83298C17.7717 6.94268 18.5528 6.30359 19.4659 6.27954C20.3706 6.30696 21.14 6.94803 21.3301 7.83298C21.392 8.17314 21.6758 8.42852 22.0205 8.45436H23.9882V11.2161H15.0126V8.45436ZM29.5116 31.3764C29.5116 32.1359 28.7521 32.6191 27.9926 32.6191H11.0082C10.2487 32.6191 9.48925 32.1359 9.48925 31.3764V11.5958C9.55968 10.8053 10.2146 10.1949 11.0082 10.1804H13.6318V11.941C13.6683 12.3278 14.0033 12.6172 14.3913 12.597H24.575C24.9701 12.6186 25.3156 12.3332 25.3689 11.941V10.1804H27.9925C28.786 10.1949 29.441 10.8052 29.5115 11.5957V31.3764H29.5116Z"
//           fill="#070707"
//         />
//         <path
//           d="M16.8426 20.4332C16.5837 20.1602 16.1538 20.1448 15.876 20.3987L13.6666 22.5045L12.7346 21.5379C12.4756 21.2649 12.0457 21.2496 11.7679 21.5034C11.5005 21.7835 11.5005 22.2243 11.7679 22.5045L13.1833 23.9544C13.3058 24.0915 13.4827 24.1674 13.6666 24.1615C13.8487 24.1589 14.0224 24.0845 14.1498 23.9544L16.8425 21.3998C17.1094 21.1549 17.1273 20.74 16.8823 20.4731C16.8698 20.4592 16.8565 20.4459 16.8426 20.4332Z"
//           fill="#070707"
//         />
//         <path
//           d="M26.7494 21.9176H18.8096C18.4282 21.9176 18.1191 22.2267 18.1191 22.608C18.1191 22.9893 18.4282 23.2985 18.8096 23.2985H26.7494C27.1307 23.2985 27.4398 22.9893 27.4398 22.608C27.4398 22.2267 27.1307 21.9176 26.7494 21.9176Z"
//           fill="#070707"
//         />
//         <path
//           d="M16.8426 14.9098C16.5837 14.6369 16.1538 14.6215 15.876 14.8753L13.6666 16.9811L12.7346 16.0145C12.4756 15.7415 12.0457 15.7261 11.7679 15.98C11.5005 16.2601 11.5005 16.7009 11.7679 16.9811L13.1833 18.431C13.3058 18.5682 13.4827 18.644 13.6666 18.6381C13.8487 18.6356 14.0224 18.5611 14.1498 18.431L16.8425 15.8764C17.1094 15.6316 17.1273 15.2166 16.8823 14.9497C16.8698 14.9358 16.8565 14.9225 16.8426 14.9098Z"
//           fill="#070707"
//         />
//         <path
//           d="M26.7494 16.3942H18.8096C18.4282 16.3942 18.1191 16.7033 18.1191 17.0846C18.1191 17.4659 18.4282 17.775 18.8096 17.775H26.7494C27.1307 17.775 27.4398 17.4659 27.4398 17.0846C27.4398 16.7033 27.1307 16.3942 26.7494 16.3942Z"
//           fill="#070707"
//         />
//         <path
//           d="M16.8426 25.9565C16.5837 25.6836 16.1538 25.6682 15.876 25.922L13.6666 28.0278L12.7346 27.0612C12.4756 26.7882 12.0457 26.7729 11.7679 27.0267C11.5005 27.3068 11.5005 27.7476 11.7679 28.0278L13.1833 29.4777C13.3058 29.6149 13.4827 29.6907 13.6666 29.6848C13.8487 29.6823 14.0224 29.6078 14.1498 29.4777L16.8425 26.9231C17.1094 26.6783 17.1273 26.2633 16.8823 25.9964C16.8698 25.9826 16.8565 25.9693 16.8426 25.9565Z"
//           fill="#070707"
//         />
//         <path
//           d="M26.7494 27.441H18.8096C18.4282 27.441 18.1191 27.7501 18.1191 28.1314C18.1191 28.5127 18.4282 28.8218 18.8096 28.8218H26.7494C27.1307 28.8218 27.4398 28.5127 27.4398 28.1314C27.4398 27.7501 27.1307 27.441 26.7494 27.441Z"
//           fill="#070707"
//         />
//       </svg>
//     );
//   } else if (tab.value === "tyre_replacement") {
//     return (
//       <svg
//         width="29"
//         height="29"
//         viewBox="0 0 29 29"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <g clipPath="url(#clip0_157_5638)">
//           <path
//             d="M8.05276 10.9192L9.98219 13.1242L12.39 10.3726L10.7804 8.53322C9.05902 6.56497 6.57304 5.43744 3.96045 5.43744H0V9.06242H3.96045C5.52781 9.06247 7.0199 9.73866 8.05276 10.9192Z"
//             fill="#070707"
//           />
//           <path
//             d="M23.5626 19.9375H23.2272C21.6598 19.9375 20.1677 19.2614 19.1349 18.0807L16.0015 14.5L19.1349 10.9192C20.1677 9.73858 21.6598 9.06246 23.2272 9.06246H23.5626V12.6874L29 7.2498L23.5626 1.8125V5.43748H23.2272C20.6146 5.43748 18.1286 6.56495 16.4072 8.53326L8.0527 18.0807C7.0199 19.2613 5.52775 19.9375 3.9604 19.9375H0V23.5625H3.96045C6.57299 23.5625 9.05902 22.435 10.7804 20.4667L13.5938 17.2515L16.4073 20.4667C18.1287 22.435 20.6146 23.5625 23.2272 23.5625H23.5626V27.1875L29.0001 21.7501L23.5626 16.3125V19.9375Z"
//             fill="#070707"
//           />
//         </g>
//         <defs>
//           <clipPath id="clip0_157_5638">
//             <rect width="29" height="29" fill="white" />
//           </clipPath>
//         </defs>
//       </svg>
//     );
//   } else if (tab.value === "transmission_repair") {
//     return (
//       <svg
//         width="29"
//         height="29"
//         viewBox="0 0 29 29"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           d="M22.9583 12.0833H16.3125V9.30719C18.0807 8.58819 19.3333 6.8572 19.3333 4.83331C19.3333 2.16769 17.1651 0 14.5 0C11.8349 0 9.66669 2.16769 9.66669 4.83331C9.66669 6.8572 10.9193 8.58819 12.6875 9.30719V18.7291C12.6875 19.7286 13.5005 20.5416 14.5 20.5416C15.4995 20.5416 16.3125 19.7286 16.3125 18.7291V18.125H18.7292C19.0631 18.125 19.3334 17.8548 19.3334 17.5208V15.7083C19.3334 15.0416 19.8756 14.5 20.5417 14.5C21.2078 14.5 21.75 15.0417 21.75 15.7083V25.375C21.75 26.0417 21.2078 26.5833 20.5417 26.5833C19.8756 26.5833 19.3334 26.0417 19.3334 25.375V22.3542C19.3334 22.0202 19.0631 21.75 18.7292 21.75H16.3125C15.9785 21.75 15.7083 22.0202 15.7083 22.3542V25.375C15.7083 26.0417 15.1661 26.5833 14.5 26.5833C13.8339 26.5833 13.2917 26.0417 13.2917 25.375V22.3542C13.2917 22.0202 13.0215 21.75 12.6875 21.75H10.2708C9.93686 21.75 9.66663 22.0202 9.66663 22.3542V25.375C9.66663 26.0417 9.12441 26.5833 8.45831 26.5833C7.79222 26.5833 7.25 26.0417 7.25 25.375V15.7083C7.25 15.0416 7.79222 14.5 8.45831 14.5C9.12441 14.5 9.66663 15.0417 9.66663 15.7083V17.5208C9.66663 17.8548 9.93686 18.125 10.2708 18.125H10.875C11.209 18.125 11.4792 17.8548 11.4792 17.5208V12.6875C11.4792 12.3535 11.209 12.0833 10.875 12.0833H6.04169C4.70882 12.0833 3.625 13.1678 3.625 14.5V26.5833C3.625 27.9156 4.70882 29 6.04169 29H22.9584C24.2912 29 25.375 27.9156 25.375 26.5833V14.5C25.375 13.1678 24.2912 12.0833 22.9583 12.0833ZM12.9896 3.625C12.4898 3.625 12.0833 3.21787 12.0833 2.71875C12.0833 2.21963 12.4898 1.8125 12.9896 1.8125C13.4893 1.8125 13.8958 2.21963 13.8958 2.71875C13.8958 3.21787 13.4893 3.625 12.9896 3.625Z"
//           fill="#070707"
//         />
//       </svg>
//     );
//   }

//   return null;
// }

function displayPopupText(value) {
  if (value === "Occasion bezichtigen") {
    return "Kom langs voor een grondige inspectie van onze tweedehands auto's. Ontdek betrouwbare opties en maak een weloverwogen keuze.";
  } else if (value === "Airco controle") {
    return "Professionele aircocontroles voor een optimaal werkend koelsysteem. Onze gespecialiseerde technici inspecteren grondig, vullen koelmiddel bij en checken op lekkages voor gegarandeerd comfort tijdens je ritten. Kom voor snelle en betrouwbare service langs en houd je airco in topconditie.";
  } else if (value === "Autostatus update") {
    return "Ontvang een volledige autostatus-update bij onze garage! Onze deskundige monteurs inspecteren grondig alle systemen, inclusief motor, remmen, verlichting en meer. Na de controle ontvang je een gedetailleerd rapport met aanbevelingen. Maak nu een afspraak en blijf veilig onderweg.";
  } else if (value === "APK") {
    return "Professionele APK-keuringen voor jouw veiligheid. Onze ervaren monteurs inspecteren grondig volgens wettelijke eisen. Hoogwaardige reparaties indien nodig. Gedetailleerde rapporten en keuringsstickers voor gemoedsrust. Kies voor onze betrouwbare service.";
  } else if (value === "Bandenwissel") {
    return "Professionele bandenwissels voor elk seizoen. Onze ervaren monteurs zorgen voor een vlotte overgang van zomer- naar winterbanden en omgekeerd. We controleren tevens de wielmoeren en bandenspanning, en adviseren bij versleten banden. Kom langs voor veiligheid en stabiliteit op de weg.";
  } else if (value === "Grote beurt") {
    return "Houd je auto in topconditie met onze uitgebreide onderhoudsbeurten. Onze ervaren monteurs inspecteren alle essentiële onderdelen en vervangen indien nodig filters, vloeistoffen en bougies voor preventief onderhoud. Vertrouw op onze expertise voor betrouwbare service en een goed onderhouden auto.";
  } else if (value === "Kleine beurt") {
    return "Snel en efficiënt onderhoud voor je auto. Grondige inspectie door ervaren monteurs: motor, remmen, verlichting en vloeistoffen. Verversing van olie en oliefilter, controle van bandenspanning en meer. Maak vandaag nog een afspraak voor betrouwbare service.";
  } else if (value === "Wintercheck") {
    return "Maak je auto winterklaar met onze grondige wintercheck. Onze ervaren monteurs controleren alle essentiële systemen, van accu tot banden, en zorgen voor bescherming tegen kou met controles van antivries en andere vloeistoffen. Maak nu een afspraak voor veilige ritten in de koudere maanden";
  } else if (value === "Zomercheck") {
    return "Zomerklaar met onze uitgebreide zomercheck. Ervaren monteurs controleren vitale onderdelen zoals airco, banden, koelvloeistof, remmen en accu. Voorbereid op zomerse ritten. Maak nu een afspraak voor een zorgeloze zomer.";
  } else if (value === "Anders") {
    return "Staat uw activiteit er niet bij, selecteer deze dan en wij helpen u dan graag verder.";
  } else {
    return "";
  }
}

function ActivityTab(activity) {
  const { values, setFieldValue } = useForm();

  function isSelected() {
    for (let i = 0; i < values.active_activities.length; i++) {
      if (values.active_activities[i].Name === activity.Name) {
        return true;
      }
    }

    return false;
  }

  return (
    <div className="inline-flex w-full flex-col gap-2">
      <div
        onClick={(e) => {
          if (!isSelected()) {
            setFieldValue("availability", null);
          }
          setFieldValue("show_availabilities", true);

          if (isSelected()) {
            setFieldValue(
              "active_activities",
              values.active_activities.filter((activeActivity) => {
                return activeActivity.Name !== activity.Name;
              })
            );
          } else {
            setFieldValue("active_activities", [
              ...values.active_activities,
              activity,
            ]);
          }
        }}
        className={classNames(
          "inline-flex items-center gap-5 px-6 py-3 rounded-xl w-full box-border cursor-pointer",
          {
            "border-2 border-[#B71922]": isSelected(),
            "border border-[#D6D6D6]": !isSelected(),
          }
        )}
      >
        <input
          type="checkbox"
          className="cursor-pointer"
          value={activity.Name}
          checked={isSelected()}
          onChange={(e) => {
            if (!isSelected()) {
              setFieldValue("availability", null);
            }

            setFieldValue("show_availabilities", true);
            setFieldValue("activity", activity);
          }}
        />
        <div>
          <div className="bg-[#F5F5F5] w-12 h-12 rounded-[8px] p-1">
            {showIcon(activity.Name)}
          </div>
        </div>
        <div>
          <p className="text-[#070707] font-Inter text-lg font-medium leading-[normal] tracking-[0.18px] ">
            {activity.Name}
          </p>
        </div>
        <div className="ml-auto">
          <InfoPopperElement
            title={activity.Name}
            text={displayPopupText(activity.Name)}
          />
        </div>
      </div>
    </div>
  );
}


function ProductStep() {
  const { values, setFieldValue } = useForm();

  const activityError = useError("active_activities");

  // const availabilityError = useError("availability");

  useEffect(() => {
    // axios
    //   .get("/wp-json/all-mobile-cars/v1/availability")
    //   .then(({ data: availabilities }) => {
    //     setFieldValue("availabilities", availabilities.data);
    //   });

    axios
      .get("/wp-json/all-mobile-cars/v1/activities")
      .then(({ data: activities }) => {
        setFieldValue("activities", activities.data);
      });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="flex flex-col w-full mb-[100px]">
      <h1 className="text-[#070707] font-inter text-[40px] font-bold leading-[normal] tracking-[0.4px] mb-[36px]">
        Waar heb je hulp bij nodig?
      </h1>

      <Preview />

      <div className="flex items-center  flex-col w-full py-2 justify-center">
        {activityError && (
          <div className="flex items-center gap-1">
            <svg
              className="shrink-0 "
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0.625C4.825 0.625 0.625 4.825 0.625 10C0.625 15.175 4.825 19.375 10 19.375C15.175 19.375 19.375 15.175 19.375 10C19.375 4.825 15.175 0.625 10 0.625ZM10 15.625C9.3125 15.625 8.75 15.0625 8.75 14.375C8.75 13.6875 9.3125 13.125 10 13.125C10.6875 13.125 11.25 13.6875 11.25 14.375C11.25 15.0625 10.6875 15.625 10 15.625ZM11.4313 5.93125L11.0125 10.9438C10.9688 11.4688 10.5312 11.875 10 11.875C9.46875 11.875 9.03125 11.4688 8.9875 10.9438L8.56875 5.93125C8.5 5.09375 9.15625 4.375 10 4.375C10.8 4.375 11.4375 5.025 11.4375 5.8125C11.4375 5.85 11.4375 5.89375 11.4313 5.93125Z"
                fill="#FE4A49"
              ></path>
            </svg>
            <p className="text-red-700 mb-0 text-[15px]">{activityError}</p>
          </div>
        )}

        {/* {availabilityError && (
          <div className="flex items-center gap-1">
            <svg
              className="shrink-0 "
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0.625C4.825 0.625 0.625 4.825 0.625 10C0.625 15.175 4.825 19.375 10 19.375C15.175 19.375 19.375 15.175 19.375 10C19.375 4.825 15.175 0.625 10 0.625ZM10 15.625C9.3125 15.625 8.75 15.0625 8.75 14.375C8.75 13.6875 9.3125 13.125 10 13.125C10.6875 13.125 11.25 13.6875 11.25 14.375C11.25 15.0625 10.6875 15.625 10 15.625ZM11.4313 5.93125L11.0125 10.9438C10.9688 11.4688 10.5312 11.875 10 11.875C9.46875 11.875 9.03125 11.4688 8.9875 10.9438L8.56875 5.93125C8.5 5.09375 9.15625 4.375 10 4.375C10.8 4.375 11.4375 5.025 11.4375 5.8125C11.4375 5.85 11.4375 5.89375 11.4313 5.93125Z"
                fill="#FE4A49"
              ></path>
            </svg>
            <p className="text-red-700 mb-0 text-[15px]">{availabilityError}</p>
          </div>
        )} */}
      </div>

      <h2 className="text-[#070707] text-2xl font-semibold leading-[normal] tracking-[0.24px] mb-[24px]">
        Hoe kunnen we je helpen?
      </h2>
      <div className="inline-flex flex-col space-y-[16px] w-full ">
        {values.activities.map((activity, index) => (
          <ActivityTab key={index} {...activity} index={index} />
        ))}
      </div>
      
    </div>
  );
}

export default createStep({
  component: <ProductStep />,
  validation: {
    // availability: yup.object().required("Beschikbaarheid is vereist."),
    active_activities: yup.array().min(1, "Minimaal 1 activiteit is vereist."),
  },
});
